<template>
  <schedule-main></schedule-main>
</template>

<script>
import ScheduleMain from '../components/Schedule';

export default {
  name: 'schedule-page',
  components: {
    'schedule-main': ScheduleMain,
  },
};
</script>
